export enum USER_FLOW_EVENTS {
  MARK_AS_DONE_TRANSLATION = "MARK_AS_DONE_TRANSLATION",
  MARK_AS_DONE_VOICEOVER = "MARK_AS_DONE_VOICEOVER",
  MARK_AS_DONE_TRANSLATION_VOICEOVER = "MARK_AS_DONE_TRANSLATION_VOICEOVER",
  MARK_AS_DONE_QA = "MARK_AS_DONE_QA"
}
